export default "__VITE_ASSET__DGIUg9tw__"